import React from 'react'
import IconBase from './IconBase'

const Down = props => (
  <IconBase {...props} viewBox="0 0 41 24">
    <path d="M18.5 22.6L1.3 5.3c-1.1-1.1-1.1-2.9 0-4s2.9-1.1 4 0l15.2 15.3L35.7 1.4c1.1-1.1 2.9-1.1 4 0s1.1 2.9 0 4L22.5 22.6a2.84 2.84 0 0 1-4 0z" />
  </IconBase>
)

export default Down
